import { getStudent } from '@/game/GameComponents/PhaserGame/GameInstance';
import { ResponsivenessManager } from '@/game/GameComponents/PhaserGame/Managers/ResponsivenessManager';
import { DEFAULT_SCALE_DOWN_CONFIG } from '@/game/GameComponents/PhaserGame/Types/ManagerTypes/ResponsivenessManagerTypes';
import {
  getAnchorPlugin,
  waitForMilliseconds,
} from '@/game/GameComponents/PhaserGame/Utils/PhaserUtils';

/* START OF COMPILED CODE */

import NPC from '../World/NPC';
import Player from '../World/Player';
/* START-USER-IMPORTS */

/* END-USER-IMPORTS */

export default class DuelEntryScreen extends Phaser.GameObjects.Container {
  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 0, y ?? 0);

    // backing
    const backing = scene.add.image(555, 383, 'placeholder-square');
    backing.scaleX = 99;
    backing.scaleY = 99;
    backing.tintFill = true;
    backing.tintTopLeft = 0;
    backing.tintTopRight = 0;
    backing.tintBottomLeft = 0;
    backing.tintBottomRight = 0;
    this.add(backing);

    // mainContainer
    const mainContainer = scene.add.container(0, 0);
    this.add(mainContainer);

    // player
    const player = new Player(scene, -304, 288);
    player.scaleX = 15;
    player.scaleY = 15;
    mainContainer.add(player);

    // nPC
    const nPC = new NPC(scene, 304, 272);
    nPC.scaleX = 15;
    nPC.scaleY = 15;
    mainContainer.add(nPC);

    // playerName
    const playerName = scene.add.bitmapText(-416, 320, 'Aronui', 'Player 1');
    playerName.setOrigin(0, 0.5);
    playerName.tintTopLeft = 15130076;
    playerName.tintTopRight = 15130076;
    playerName.tintBottomLeft = 15130076;
    playerName.tintBottomRight = 15130076;
    playerName.text = 'Player 1';
    playerName.fontSize = -48;
    mainContainer.add(playerName);

    // opponentName
    const opponentName = scene.add.bitmapText(192, 320, 'Aronui', 'Player 2');
    opponentName.setOrigin(0, 0.5);
    opponentName.tintTopLeft = 15130076;
    opponentName.tintTopRight = 15130076;
    opponentName.tintBottomLeft = 15130076;
    opponentName.tintBottomRight = 15130076;
    opponentName.text = 'Player 2';
    opponentName.fontSize = -48;
    mainContainer.add(opponentName);

    // vsText
    const vsText = scene.add.bitmapText(0, 0, 'Aronui', 'VS');
    vsText.setOrigin(0.5, 0.5);
    vsText.tintTopLeft = 15130076;
    vsText.tintTopRight = 15130076;
    vsText.tintBottomLeft = 15130076;
    vsText.tintBottomRight = 15130076;
    vsText.text = 'VS';
    vsText.fontSize = -96;
    vsText.align = 1;
    mainContainer.add(vsText);

    // player (prefab fields)
    player.interactionEnabled = false;

    this.player = player;
    this.nPC = nPC;
    this.playerName = playerName;
    this.mainContainer = mainContainer;
    // awake handler
    this.scene.events.once('scene-awake', () => this.awake());

    /* START-USER-CTR-CODE */
    this.setDepth(9999);
    this.scene.tweens.add({
      targets: this.player,
      x: this.player.x + 32,
      duration: 2000,
      repeat: 0,
      ease: 'Cubic',
    });

    this.scene.tweens.add({
      targets: this.nPC,
      x: this.nPC.x - 32,
      duration: 2000,
      repeat: 0,
      ease: 'Cubic',
    });

    this.playerName.setText(getStudent().studentFirstName);
    this.awake();
    /* END-USER-CTR-CODE */
  }

  public player: Player;
  public nPC: NPC;
  private playerName: Phaser.GameObjects.BitmapText;
  private mainContainer: Phaser.GameObjects.Container;

  /* START-USER-CODE */

  async awake() {
    await waitForMilliseconds(this.scene.time, 1);
    // Responsiveness.
    const anchor = getAnchorPlugin(this.scene);
    if (anchor) {
      anchor.add(this.mainContainer, {
        centerX: '50%',
        centerY: '50%',
      });
    }

    ResponsivenessManager.MakeElementScaleDownWithGameSize(this.mainContainer, {
      ...DEFAULT_SCALE_DOWN_CONFIG,
      accountForHeight: true,
      scaleModifier: 0.5,
    });
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
